'use client';

import type { Account } from '@repo/api-gw-sdk';
import { useCallback } from 'react';
import semver from 'semver';

import { useFeatureFlags } from '@/contexts/useFeatureFlags';

export const useIsAccountFeatureSupported = () => {
  const { ManualPermissionsSetup } = useFeatureFlags();

  return useCallback(
    (featureVersion: string, account: Account): boolean => {
      if (ManualPermissionsSetup) {
        return true;
      }
      return Boolean(
        isFeatureSupported(featureVersion, account.installedVersion)
      );
    },
    [ManualPermissionsSetup]
  );
};

const isFeatureSupported = (
  featureVersion: string,
  installedVersion?: string
) => {
  return (
    installedVersion &&
    semver.valid(installedVersion) &&
    semver.gte(installedVersion, featureVersion)
  );
};
